import { insert_image } from "./drawing-image-icons";
import { DrawingModuleContainer } from "../../ModuleBase/DrawingModuleContainer";
import { DrawImageModule } from "./image-module";
import { getAllImages } from "../../../../data/images";

export class DrawImageModuleContainer extends DrawingModuleContainer {
	constructor(canvas) {
		super(canvas);

		this.moduleId = "images";
		this.toolbarWidth = "40px";
		this.icon = insert_image;
		this.label = "images";

		getAllImages(INSP.APP.inspId)
			.then(images => {
				images.map(i => (i.url = this._createImageUrl(i)));
				this._items = images;
				this.submodules = images.map(i => new DrawImageModule(this.canvas, i));
				this.firstUpdated();
			})
			.catch(a => console.log(a));
	}

	_createImageUrl(img) {
		const blob = new Blob([img.data], { type: img.dataMimeType || mimeType });
		return URL.createObjectURL(blob);
	}
}

window.customElements.define(
	"inspx-draw-image-container",
	DrawImageModuleContainer
);
